import { Trans, useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, colors, fontWeights } from '@/styles'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 30px 170px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    align-items: flex-start;
    padding-bottom: 100px;
  }
`

const DescriptionText = styled.p`
  font-size: 18px;
  font-weight: ${fontWeights.medium};
  letter-spacing: -0.2px;
  line-height: 24px;
  text-align: center;
  max-width: 700px;
  margin: 0 0 30px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 14px;
    letter-spacing: -0.34px;
    line-height: 20px;
    text-align: left;
    max-width: unset;
    margin: 0 0 20px;
  }

  :last-child {
    margin: 0;
  }

  a {
    margin: 10px 0;
  }
`

const Link = styled.a`
  text-decoration: none;
  color: ${colors.link};
`

const Press = () => {
  const { t } = useTranslation('about')

  return (
    <Wrapper>
      <DescriptionText>
        <Trans i18nKey="about:press.description_1">
          Inspired by their own hassles encountered as both tenants and
          landlords, liv.rent set out to make rental easy.
        </Trans>
      </DescriptionText>
      <DescriptionText>
        <Trans i18nKey="about:press.description_2">
          The result? An all-in-one, simple & convenient mobile platform that
          securely digitizes every step of the rental process.
        </Trans>
      </DescriptionText>
      <DescriptionText>
        <Trans i18nKey="about:press.description_3">
          liv.rent marries smart technology with verified information to foster
          a trusted community, building better relationships between tenants and
          landlords while eliminating stress and uncertainty from the rental
          process.
        </Trans>
      </DescriptionText>
      <DescriptionText>
        <Link
          rel="noopener"
          target="_blank"
          href="https://www.dropbox.com/s/ahoowc9krcdsbm6/2020-02-24_Liv.Rent%20Press%20Kit_Final.pdf?dl=0"
        >
          <b>{t('about:Download Press Kit')}</b>
        </Link>
      </DescriptionText>
      <DescriptionText>
        <Trans i18nKey="about:press.contact">
          Contact us at{' '}
          <Link
            style={{ textDecoration: 'underline', color: colors.regular }}
            href="mailto:media@liv.rent"
          >
            media@liv.rent
          </Link>{' '}
          for all other inquiries.
        </Trans>
      </DescriptionText>
    </Wrapper>
  )
}

export default Press
